"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _RootComponent = _interopRequireDefault(require("../RootComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FirstComponentLoadRunner =
/*#__PURE__*/
function () {
  function FirstComponentLoadRunner(connector, firstComponent) {
    _classCallCheck(this, FirstComponentLoadRunner);

    this.connector = connector;
    this.firstComponent = firstComponent;
  }

  _createClass(FirstComponentLoadRunner, [{
    key: "run",
    value: function run(callback) {
      var _this = this;

      var location = this.connector.historyManager.getLocation();
      this.connector.request(location.pathname);
      this.connector.componentResolver.setComponent(this.firstComponent);
      callback(function (props) {
        return _react.default.createElement(_RootComponent.default, _objectSpread({
          connector: _this.connector
        }, props));
      });
    }
  }]);

  return FirstComponentLoadRunner;
}();

exports.default = FirstComponentLoadRunner;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvcnVubmVyL0ZpcnN0Q29tcG9uZW50TG9hZFJ1bm5lci5qcyJdLCJuYW1lcyI6WyJGaXJzdENvbXBvbmVudExvYWRSdW5uZXIiLCJjb25uZWN0b3IiLCJmaXJzdENvbXBvbmVudCIsImNhbGxiYWNrIiwibG9jYXRpb24iLCJoaXN0b3J5TWFuYWdlciIsImdldExvY2F0aW9uIiwicmVxdWVzdCIsInBhdGhuYW1lIiwiY29tcG9uZW50UmVzb2x2ZXIiLCJzZXRDb21wb25lbnQiLCJwcm9wcyIsIlJlYWN0IiwiY3JlYXRlRWxlbWVudCIsIlJvb3RDb21wb25lbnQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFDQTs7Ozs7Ozs7Ozs7Ozs7SUFFcUJBLHdCOzs7QUFDbkIsb0NBQVlDLFNBQVosRUFBdUJDLGNBQXZCLEVBQXVDO0FBQUE7O0FBQ3JDLFNBQUtELFNBQUwsR0FBaUJBLFNBQWpCO0FBQ0EsU0FBS0MsY0FBTCxHQUFzQkEsY0FBdEI7QUFDRDs7Ozt3QkFFR0MsUSxFQUFVO0FBQUE7O0FBQ1osVUFBTUMsUUFBUSxHQUFHLEtBQUtILFNBQUwsQ0FBZUksY0FBZixDQUE4QkMsV0FBOUIsRUFBakI7QUFDQSxXQUFLTCxTQUFMLENBQWVNLE9BQWYsQ0FBdUJILFFBQVEsQ0FBQ0ksUUFBaEM7QUFFQSxXQUFLUCxTQUFMLENBQWVRLGlCQUFmLENBQWlDQyxZQUFqQyxDQUE4QyxLQUFLUixjQUFuRDtBQUVBQyxNQUFBQSxRQUFRLENBQUMsVUFBQ1EsS0FBRCxFQUFXO0FBQ2xCLGVBQU9DLGVBQU1DLGFBQU4sQ0FBb0JDLHNCQUFwQjtBQUNMYixVQUFBQSxTQUFTLEVBQUUsS0FBSSxDQUFDQTtBQURYLFdBRUZVLEtBRkUsRUFBUDtBQUlELE9BTE8sQ0FBUjtBQU1EIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFJvb3RDb21wb25lbnQgZnJvbSBcIi4uL1Jvb3RDb21wb25lbnRcIjtcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgRmlyc3RDb21wb25lbnRMb2FkUnVubmVyIHtcbiAgY29uc3RydWN0b3IoY29ubmVjdG9yLCBmaXJzdENvbXBvbmVudCkge1xuICAgIHRoaXMuY29ubmVjdG9yID0gY29ubmVjdG9yO1xuICAgIHRoaXMuZmlyc3RDb21wb25lbnQgPSBmaXJzdENvbXBvbmVudDtcbiAgfVxuXG4gIHJ1bihjYWxsYmFjaykge1xuICAgIGNvbnN0IGxvY2F0aW9uID0gdGhpcy5jb25uZWN0b3IuaGlzdG9yeU1hbmFnZXIuZ2V0TG9jYXRpb24oKTtcbiAgICB0aGlzLmNvbm5lY3Rvci5yZXF1ZXN0KGxvY2F0aW9uLnBhdGhuYW1lKTtcblxuICAgIHRoaXMuY29ubmVjdG9yLmNvbXBvbmVudFJlc29sdmVyLnNldENvbXBvbmVudCh0aGlzLmZpcnN0Q29tcG9uZW50KTtcblxuICAgIGNhbGxiYWNrKChwcm9wcykgPT4ge1xuICAgICAgcmV0dXJuIFJlYWN0LmNyZWF0ZUVsZW1lbnQoUm9vdENvbXBvbmVudCwge1xuICAgICAgICBjb25uZWN0b3I6IHRoaXMuY29ubmVjdG9yLFxuICAgICAgICAuLi5wcm9wc1xuICAgICAgfSk7XG4gICAgfSk7XG4gIH1cbn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/async-react-router/lib/runner/FirstComponentLoadRunner.js
// module id = 251
// module chunks = 0